import * as React from 'react';
import { Col } from 'react-bootstrap';
import { flattenBenefits } from '../../schemeChoice.helpers';
import { pickBenefitsQuote } from '../../schemeChoice.viewModels';
import {IChannel} from '../../../../../../data/api/models';

interface IQuoteLeftHelperProps {
    quote: any;
    tripType: string;
    product: any;
    quoteOrder: 'standard' | 'side-by-side';
    moreInfo: boolean;
    renderDefinition: (name: string, defName?: string, icon?: string) => any;
    orderedTripTypes: any[];
    channel: IChannel;
    showAnnual: boolean;
}

export default class LeftSideHelper extends React.PureComponent<IQuoteLeftHelperProps> {
    public render() {
        const {
            quote,
            tripType,
            product,
            quoteOrder,
            moreInfo,
            renderDefinition,
            orderedTripTypes,
            channel,
            showAnnual,
        } = this.props;

        if (!tripType) {
            return null;
        }
        if (!orderedTripTypes || orderedTripTypes.length === 0) {
            return null;
        }

        const referenceQuote = orderedTripTypes
            .map((tt) => pickBenefitsQuote(tt, tripType))
            .find((q) => !!q);

        const benefits = referenceQuote && referenceQuote.benefits;
        if (!benefits) {
            return null;
        }

        const benefitsFlatten = flattenBenefits(benefits, channel.key);

        let tripTypeDefinition = 'trip_type_single';
        if (tripType === 'annual') {
            tripTypeDefinition = 'trip_type';
        }

        const tripTypeArrow = ['trip-type-arrow', tripType === 'annual' ? 'trip-type-arrow--annual' : ''];
        const tripTypeArrowClass = tripTypeArrow.join(' ');

        const renderSingleTile = 'Single Trip Cover';
        let divCheck = 0;

        if (document.getElementById('signpost-quote-div')) {
            divCheck = document.getElementById('signpost-quote-div')!.offsetHeight + 20;
        }

        let breakingPoint = 2;
        if (channel.key === 'tpl-b2c') {
            breakingPoint = 3;
        }
        const renderAnnualTitle = product.metadata.trip_type.annual;

        const renderBenefit = (benefit = null, key, title = null) => {
            return (
                <div
                    key={key}
                    className="benefit-container"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        paddingTop: '20px',
                        paddingBottom: '20px',
                        marginBottom: '10px',
                    }}
                >
                    <div
                         style={{
                             display: 'flex',
                             alignItems: 'center',
                             height: '40px',
                             fontSize: '14px',
                             marginBottom: '10px',
                         }}>
                        {benefit ? benefit.name : title}
                    </div>

                    {benefit && benefit.hasSubBenefits && (
                        <div>
                            {benefit.subBenefits.map((subBenefit, index) => (
                                <div key={index}
                                     style={{
                                         height: '25px',
                                         alignItems: 'center',
                                         marginLeft: '1px',
                                         fontSize: '13px',
                                         marginBottom: subBenefit.name.length > 41 ? '8px' : '3px',
                                         lineHeight: '14px',
                                     }}
                                >
                                    •{subBenefit.name}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            );
        };

        return (
            <Col className={`col-xs-4 hide-mobile`}>
                <div className="quote-helper" style={{display: 'flex', flexDirection: 'column'}}>
                    {quoteOrder === 'standard' ? (
                        <div>
                            <div className="trip-type-container">
                                <div className={tripTypeArrowClass + '--single'}>
                                    {renderDefinition(tripTypeDefinition, null, 'FaInfo')}
                                    {tripType === 'single' ? renderSingleTile : renderAnnualTitle}
                                </div>
                            </div>

                            {tripType === 'single' && product.metadata.trip_type.annual && showAnnual && (
                                <div className="trip-type-container">
                                    <div className={tripTypeArrowClass}>
                                        {renderDefinition('trip_type', null, 'FaInfo')}
                                        {renderAnnualTitle}
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div style={{marginBottom: '4px'}}>
                            <div className="trip-type-container"/>
                        </div>
                    )}

                    {!!quote.signpost && <div className={'signpost-quote-container'} style={{height: divCheck}}/>}

                    {renderBenefit(
                        null,
                        'Standard Excess',
                        'Standard Excess',
                    )}

                    {benefitsFlatten.map((benefit, key) => {
                        if (key === breakingPoint) {
                            return (
                                <div key={key} style={{display: 'flex', flexDirection: 'column'}}>
                                    {renderBenefit(
                                        benefit,
                                        key,
                                    )}
                                    {renderBenefit(
                                        null,
                                        'Insurance Product Information Document',
                                        'Insurance Product Information Document',
                                    )}
                                    {renderBenefit(
                                        null,
                                        'View full detail',
                                        'View full detail',
                                    )}
                                </div>
                            );
                        }

                        if (key > breakingPoint) {
                            if (!moreInfo) {
                                return null;
                            }
                            renderBenefit(
                                benefit,
                                key,
                            );
                        }

                        return (
                            renderBenefit(
                                benefit,
                                key,
                            )
                        );
                    })}
                </div>
            </Col>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/SchemeChoiceB/components/LeftSideHelper/index.tsx